import React, { useEffect } from "react";
import { nanoid } from "nanoid";

import { Home } from "./pages/Home";
import { useApp } from "./contexts/app";

function App() {
  const { dispatch } = useApp();

  useEffect(() => {
    // Get uuid
    let uuid = window.localStorage.getItem("hive-webapp-uuid");
    if (!uuid) {
      uuid = nanoid();
      window.localStorage.setItem("hive-webapp-uuid", uuid);
    }
    console.log("anonymous user uuid", uuid);
    dispatch({ type: "SET_USER_UUID", payload: { uuid } });

    ///// Already done in server/firebase.ts
    // Firebase anonymous sign in
    // const auth = getAuth();
    // signInAnonymously(auth)
    //   .then(() => {
    //     // Signed in..
    //   })
    //   .catch((error) => {
    //     const errorCode = error.code;
    //     const errorMessage = error.message;
    //     // ...
    //   });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex flex-column border flex-grow-1">
      {/* <img src={logo} className="App-logo" alt="logo" /> */}

      <Home />
    </div>
  );
}

export default App;
